'use strict'

import _ from 'lodash'

import State from './State'

// import Debug from 'debug'
// const $debug = Debug('mutation')

const findMapByKey = (state, key) => {
  if (!_.hasIn(state, key)) {
    throw new Error('findMapByKey state does not have:' + key)
  }
  let map = _.get(state, key)
  if (!_.isObject(map)) {
    throw new Error('findMapByKey not found:' + key)
  }
  return map
}

export default {

  SET(state, { key, value }) {
    if (key.match(/\.|\[/)) {
      _.set(state, key, value)
    } else {
      state[key] = value
    }
  },

  NULL(state, { key }) {
    if (key.match(/\.|\[/)) {
      _.set(state, key, null)
    } else {
      state[key] = null
    }
  },

  UPDATE_CLAIMS(state, claims) {
    if (!_.isArray(claims)) {
      return false
    }
    state.claims = claims.map(claim => {
      claim.createdAt = claim.created
      claim.amount = _.toNumber(claim.amount)

      if (claim.answers && _.isString(claim.answers)) {
        claim.answers = JSON.parse(claim.answers)
      }

      let content = {}
      _.each(claim.answers, item => {
        content[item.name] = item.value
      })
      claim.content = content

      return claim
    })
  },

  COLLECTION_UPDATE(state, { key, value, uid = null, primaryKey = 'id', addMissing = true }) {
    let map = findMapByKey(state, key)

    if (!uid && value[primaryKey]) {
      uid = value[primaryKey]
    }

    if (!uid) {
      throw new Error(`Can not add entity missing primaryKey: ${primaryKey}`)
    }
    let idx = _.findIndex(map, [primaryKey, uid])
    if (idx > -1) {
      map.splice(idx, 1, value)
    } else if (addMissing) {
      map.push(value)
    }
  },

  // MAP_UPDATE(state, { key, value, uid = null, primaryKey = 'id', addMissing = true }) {
  //   let map = findMapByKey(state, key)
  //   if (!uid && value[primaryKey]) {
  //     uid = value[primaryKey]
  //   }
  //   if (!uid) {
  //     throw new Error(`Can not add entity missing primaryKey: ${primaryKey}`)
  //   }
  //   if (map[uid] || addMissing) {
  //     $debug('SET', uid)
  //     Vue.set(map, uid, value)
  //   }
  // },
  //
  // MAP_REMOVE(state, { key, uid }) {
  //   let map = findMapByKey(state, key)
  //   if (map[uid]) {
  //     Vue.delete(map, uid)
  //   }
  // },
  //
  // MAP_EMPTY(state, key) {
  //   Vue.set(state, key, {})
  // },

  RESET_DEFAULT_STATE(state) {
    let cleanState = JSON.parse(JSON.stringify(State))
    _.each(cleanState, (value, key) => {
      _.set(state, key, value)
    })
  },

}
